import './Job.css'
import Option from "./Option"
const Job = ({job,options,setOptions})=>{
    
    function handleFilter(option){

        if (!options.includes(option)){
            setOptions(prev =>[...prev,option])
        }
    }
    let stack = [...job.languages,...job.tools,job.level,job.role]
    return (
        <div className="job">
            <div className='left'>
                <div className="logo">
                    <img src={job.logo} alt="logo" />
                </div>
                <div className="info">
                    <div className="top">
                        <div className='name'>
                            {job.company}
                        </div>
                        {
                            job.new && <div className='new'>NEW!</div>
                        }
                        {
                            job.featured && <div className='featured'>FEATURED</div>
                        }
                    </div>
                    <div className="center">
                        {job.position}
                    </div>
                    <div className="bottom">
                        <div className='other'>{job.postedAt}</div>
                        <div className='separator'>.</div>
                        <div className='other'>{job.contract}</div>
                        <div className='separator'>.</div>
                        <div className='other'>{job.location}</div>

                    </div>
                </div>
            </div>
            <div className="stack">
                {
                    stack.map(el=>
                        <div key={el} onClick={()=>handleFilter(el)}>
                            <Option option={el} />
                        </div>
                     )
                }
            </div>
        </div>
    )
}
export default Job